export default __webpack_public_path__ + "static/media/mdi_arrow-right-circle.f77acb74.svg";